import Head from "next/head";
import CypherTables from "../../../../src/tables/s14/CypherTables.tsx";

export default function CypherTablesPage({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 14 Cypher Tables</title>
      </Head>
      <CypherTables tables={tables} />
    </>
  );
}
export async function getStaticProps() {
  const tablesResp = await fetch(`https://ap.tft.tools/static/s14/crime.json`);
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
